import { GenericLazyString } from '@eventbrite/i18n';

export enum EntryPointProps {
    CreatorHome = 'creator-home-main',
    CreatorHomeSidebar = 'creator-home-sidebar',
    Checkout = 'checkout',
    Events = 'events',
    LoggedOutEventCreate = 'logged-out-event-create',
}

export enum CohortProps {
    CommercialProven = 'commercial-proven',
    CommercialUnproven = 'commercial-unproven',
    NewBusiness = 'new-business',
}

export enum HeapActionProps {
    SalesEligibleBannerShown = 'SalesOnboardingViewPage',
    SalesEligibleBannerClicked = 'SalesOnboardingClickLearnMore',
    SalesEligibleModalShown = 'SalesOnboardingViewModal',
    SalesEligibleModalSubmitted = 'SalesOnboardingSubmitForm',
}

export interface TitleProps {
    title: GenericLazyString | string;
}

export interface DescriptionProps {
    description: GenericLazyString | string;
}

export interface ButtonProps {
    buttonText: GenericLazyString | string;
    handleButtonClick: React.MouseEventHandler<HTMLElement>;
}

export interface SubmitFormProps {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
}

export interface SalesEligibleBannerProps {
    entryPoint: EntryPointProps;
    updateUserContextFromSalesEligible?: (formData: SubmitFormProps) => void;
}

export type SalesEligibleModalProps = {
    handleClose: () => void;
    handleComplete: () => void;
    cohort: CohortProps;
    entryPoint: EntryPointProps;
    updateUserContextFromSalesEligible?: (formData: SubmitFormProps) => void;
};

export type ModalFormValues = {
    firstName: string;
    lastName: string;
    email: string;
    countryCode: string;
    phoneNumber: string;
};

export interface SaveSalesEligibleRequest {
    userId: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
    email: string;
    cohort: CohortProps;
    activeOrgId: string;
}

export interface CreatorPersonalizationScoreItem {
    gtf: number;
    created_at: number;
    organization_id: string;
    score: number;
    tickets_sold: number;
    lifetime_event_count: number;
    metric: string;
}

interface Pagination {
    limit: number;
}

export interface CreatorPersonalizationScoreResponse {
    items: CreatorPersonalizationScoreItem[];
    pagination: Pagination;
}

export interface CohortCriteria {
    orgAgeInMonths: number;
    lifetime_event_count: number;
    score: number;
    gtf: number;
}

export interface Answer {
    value: number | string;
    name: string;
}

export interface Answers {
    [questionId: string]: Answer[];
}

export enum CreatorSegmentationCategory {
    General = 'general',
    PotentialHighValue = 'potential-high-value',
}
